import * as queryString from 'query-string';

import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

function filterSearchParams(search: Record<string, string | string[] | null | undefined>) {
    return Object.fromEntries(Object.entries(search).filter(([key]) => !key.startsWith('utm_')));
}

/**
 * When rendered, this component filters out all UTM-related
 * search parameters and adds them to the state instead.
 */
export const SearchParams = () => {
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        // If a route's location contains a search query,
        // filter UTM params and copy the original string
        // into state for analytics.
        if (location?.search) {
            const search = queryString.parse(location.search);

            const pageState = {
                ...search,
                ...(typeof location.state === 'object' ? location.state : null),
                // pass search params here, to have access to it in Route (@modernhealth/web-analytics) and be able to separate it from rest of location.state properties
                ...(location?.search && { searchParams: location.search }),
            };

            history.replace({
                ...location,
                search: queryString.stringify(filterSearchParams(search)),
                state: pageState,
            });
        }
        // We don't want to trigger this on location updates
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
